import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { logOut } from '../utils/firebase';

function AccessDeniedPage() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <Container style={{ maxWidth: 420 }}>
        <Card className="text-center">
          <Card.Body className="p-5">
            <i className="bi bi-shield-lock" style={{ fontSize: '3rem', color: 'var(--text-secondary)' }}></i>
            <h3 className="mt-3">Access Denied</h3>
            <p className="text-muted">
              This is the development version of Plum. Access is restricted to administrators.
            </p>
            <Button variant="outline-secondary" onClick={() => logOut()}>
              Sign Out
            </Button>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default AccessDeniedPage;
